import { render, staticRenderFns } from "./OrdersView.vue?vue&type=template&id=1259a7b1&scoped=true&"
import script from "./OrdersView.vue?vue&type=script&lang=ts&"
export * from "./OrdersView.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersView.vue?vue&type=style&index=0&id=1259a7b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1259a7b1",
  null
  
)

export default component.exports